"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeliverySummary = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useCouriersQuery = require("../../api/useCouriersQuery");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _getOutOfStockQuantity = require("../../utils/getOutOfStockQuantity");
var _styles = require("../CourierSelection/styles");
var _AddressInfo = require("../DeliveryBox/AddressInfo");
var _styles2 = require("../DeliveryOptions/styles");
var _Availability = require("../SelectPickupPointDialog/components/Availability");
var _styles3 = require("../SelectPickupPointDialog/components/PickupPointCard/styles");
var _shared = require("../shared");
var _DeliverySummarySkeleton = require("./DeliverySummarySkeleton");
var _styles4 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeliverySummary = ({
  activeCourier,
  isLoading,
  onDeliveryAddressChange,
  selectedItem
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    addressId,
    courierLogo,
    courierName,
    estimatedDelivery,
    deliveryFee = 0,
    deliveryMethod,
    outOfStockProducts,
    outOfStockQuantity
  } = selectedItem ?? {};
  const isHomeDelivery = deliveryMethod === _models.AddressItemDeliveryMethod.Home;

  // optionally loading only for home delivery (via providing addressId)
  const {
    couriers,
    isCouriersLoading
  } = (0, _useCouriersQuery.useCouriersQuery)({
    activeCourier,
    addressId: isHomeDelivery ? addressId : undefined,
    shouldCheckValidCourier: false
  });
  if (!selectedItem) {
    return null;
  }
  if (isLoading || isCouriersLoading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeliverySummarySkeleton.DeliverySummarySkeleton, {});
  }
  const addressLabel = formatMessage(deliveryMethod === _models.AddressItemDeliveryMethod.Home ? 'shippingAddress' : 'pickupPoint');
  let usedCourierName = courierName;
  let usedDeliveryFee = deliveryFee;
  let image = courierLogo;
  if (deliveryMethod === _models.AddressItemDeliveryMethod.Home) {
    const courierInfo = couriers?.find(courier => courier.deliveryChannelId === activeCourier);
    usedCourierName = courierInfo?.name;
    usedDeliveryFee = courierInfo?.deliveryFee ?? 0;
    image = courierInfo?.image;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles4.FlatDeliveryWrapper, {
    ...getTestIdProps(_models.TestId.DeliverySummary),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_shared.FlatLayoutWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryHeader, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          variant: "h6",
          children: formatMessage('delivery')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_checkoutUi.MiniButton, {
          onClick: onDeliveryAddressChange,
          children: formatMessage('edit')
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryContent, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryInfo, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            fontWeight: "bold",
            children: addressLabel
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressInfo.AddressInfo, {
            ...selectedItem,
            isFlatSelection: true
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryInfo, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            fontWeight: "bold",
            children: formatMessage('deliveryMethod')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryCourierInfo, {
            children: [usedCourierName ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: usedCourierName
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: !usedDeliveryFee ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.FreeLabel, {
                children: formatMessage('free')
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                ...getTestIdProps(_models.TestId.CourierFee),
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
                  children: usedDeliveryFee
                })
              })
            }), image ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Image, {
              src: image.src,
              alt: image.alt,
              ...getTestIdProps(_models.TestId.CourierImage),
              ownerState: {
                isFlatSelection: true
              }
            }) : null]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles4.DeliverySummaryInfo, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
            fontWeight: "bold",
            children: formatMessage('expectedDelivery')
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles3.DateAndAvailability, {
            children: [estimatedDelivery ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              children: estimatedDelivery
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Availability.Availability, {
              outOfStockQuantity: (0, _getOutOfStockQuantity.getOutOfStockQuantity)({
                outOfStockProducts,
                outOfStockQuantity
              })
            })]
          })]
        })]
      })]
    })
  });
};
exports.DeliverySummary = DeliverySummary;